import React from 'react';
import { setContentSubmissionModalOpen } from '@/redux/contentSubmission/contentSubmissionActions';
import { CONTENT_SUBMISSION_MODAL_PATH } from '@/utils/constants/contentSubmission';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification, IProfile } from '@Saral-Influencer-Marketing/saral-utils/src/models';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import RightArrow from '@/components/Icons/icons/RightArrow';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

interface Props {
  notification: INotification;
  setShowNotificationDropdown: React.Dispatch<React.SetStateAction<boolean>>;
}

const ContentSubmissionNotification = ({ notification, setShowNotificationDropdown }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const influencerData = notification?.influencerId as unknown as IProfile;

  const influencerName = notification?.content?.fullName as unknown as string;

  const influencerProfileImg = notification?.content?.profileImg as unknown as string;

  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent src={influencerProfileImg} alt={influencerName} />
      </div>
      <div className="text-div ">
        <h3 className="text-sm font-normal text-default">{notification?.title}</h3>

        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={() => {
              navigate(
                `/dashboard/profile/${influencerData.lists?.[0]}/${influencerData?._id}?${CONTENT_SUBMISSION_MODAL_PATH}=true`
              );
              dispatch(setContentSubmissionModalOpen(true));

              setShowNotificationDropdown(false);
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">Check it out</span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default ContentSubmissionNotification;
